module.exports = __webpack_public_path__ + "img/08-sort-icon.184ce9a4.svg";